import React from "react";

function buildPageItems(currentPage, totalPages) {
    const current = Math.max(1, Math.min(Number(currentPage) || 1, totalPages));

    if (totalPages <= 8) {
        return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = new Set([1, totalPages, current]);
    for (let page = current - 2; page <= current + 2; page += 1) {
        if (page > 1 && page < totalPages) {
            pages.add(page);
        }
    }

    const sorted = Array.from(pages).sort((a, b) => a - b);
    return sorted.reduce((items, page, index) => {
        const previous = sorted[index - 1];
        if (previous && page - previous > 1) {
            items.push(`dots-${previous}-${page}`);
        }
        items.push(page);
        return items;
    }, []);
}

export default function Pagination({ currentPage, totalPages, onPageChange }) {
    const pages = Math.max(1, Number(totalPages) || 1);
    if (pages <= 1) return null;

    const current = Math.max(1, Math.min(Number(currentPage) || 1, pages));
    const items = buildPageItems(current, pages);

    return (
        <nav className="pagination" aria-label="Пагинация">
            {items.map((item) => (
                typeof item === "number" ? (
                    <button
                        key={item}
                        type="button"
                        className={`ghost-btn pagination__page${item === current ? " is-active" : ""}`}
                        onClick={() => onPageChange(item)}
                        disabled={item === current}
                        aria-current={item === current ? "page" : undefined}
                    >
                        {item}
                    </button>
                ) : (
                    <span key={item} className="pagination__dots" aria-hidden="true">
                        ...
                    </span>
                )
            ))}
        </nav>
    );
}
